import App from '@scripts/app'
import Block from './Block'
import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'

export default class BlockGridGallery extends Block {
  constructor(el) {
    super(el)

    this.isDrag = false
    this.isInit = false
    this.isReset = false
    this.diffItem = 160
    this.diffPicture = 50
    this.diffX = this.el.offsetWidth - App.windowWidth
    this.diffY = this.el.offsetHeight - App.windowHeight
    this.isDisabled = false
    this.init()
  }

  getElems() {
    super.getElems()

    this.content = this.el.querySelector('.js-grid-gallery-content')
    this.title = this.el.querySelector('.js-grid-gallery-title')
    this.titleBig = this.title.querySelector('.t--big')
    this.titleMin = this.title.querySelector('.t--min')
    this.titleSecond = this.el.querySelector('.js-grid-gallery-title-second')
    this.titleSecond.big = this.titleSecond.querySelector('.t--big')
    this.titleSecond.min = this.titleSecond.querySelector('.t--min')
    this.items = this.el.querySelectorAll('.js-grid-gallery-item')
    this.panels = this.el.querySelectorAll('.js-grid-gallery-item-panel')
    this.pictures = this.el.querySelectorAll('picture')
  }

  bindMethods() {
    super.bindMethods()

    this.itemEnter = this.itemHover.bind(this, true)
    this.itemLeave = this.itemHover.bind(this, false)
  }

  events() {
    super.events()

    this.addEvent({
      target: this.content, name: 'mouseenter', callback: this.contentHover.bind(this, true)
    })

    this.addEvent({
      target: this.content, name: 'mouseleave', callback: this.contentHover.bind(this, false)
    })

    this.items.forEach((item) => {
      this.addEvent({
        target: item, name: 'mouseenter', callback: this.itemEnter
      })

      this.addEvent({
        target: item, name: 'mouseleave', callback: this.itemLeave
      })
    })
  }

  init() {
    this.titleBig.split = new SplitText(this.titleBig, { type: 'chars' })
    gsap.set(this.titleBig.split.chars, { x: -80, filter: 'blur(18px)', opacity: 0, scale: 0.95 })

    gsap.set(this.items, { scale: 0.2, clipPath: 'inset(50%)' })
    gsap.set(this.content, { scale: 0.4 })
    gsap.set(this.titleSecond, { opacity: 0, filter: 'blur(18px)' })
    gsap.set(this.titleMin, { opacity: 0 })
    gsap.set(this.title, { scale: 0.95 })

    this.pictures.forEach((item) => {
      item.speed = item.parentNode.parentNode.dataset.speed
    })
  }

  quickTo() {
    const duration = 4.2
    const ease = 'expo.out'

    this.pictureX = gsap.quickTo(this.pictures, 'x', { duration, ease })
    this.pictureY = gsap.quickTo(this.pictures, 'y', { duration, ease })
    this.moveX = gsap.quickTo(this.content, 'x', { duration, ease })
    this.moveY = gsap.quickTo(this.content, 'y', { duration, ease })

    this.items.forEach((item) => {
      item.moveX = gsap.quickTo(item, 'x', { duration, ease })
      item.moveY = gsap.quickTo(item, 'y', { duration, ease })
    })
  }

  pointermove(e) {
    super.pointermove(e)

    if (!this.isInit || App.header.opened || this.isDisabled || this.isReset) return

    const xPercent = (e.clientX / App.windowWidth) - 0.5
    const yPercent = (e.clientY / App.windowHeight) - 0.5
    const xPicture = xPercent * -this.diffPicture
    const yPicture = yPercent * -this.diffPicture
    const xItem = xPercent * this.diffItem
    const yItem = yPercent * this.diffItem
    const x = xPercent * -this.diffX
    const y = yPercent * -this.diffY

    this.pictureX(xPicture)
    this.pictureY(yPicture)
    this.moveX(x)
    this.moveY(y)

    this.items.forEach((item) => {
      item.deltaX = xItem * item.dataset.speed
      item.deltaY = yItem * item.dataset.speed

      item.moveX(item.deltaX)
      item.moveY(item.deltaY)
    })
  }

  // resetMove() {
  //   return gsap.to([this.pictures, this.items, this.content], {
  //     duration: 1.7,
  //     x: 0,
  //     y: 0,
  //     ease: 'power2.inOut'
  //   })
  // }

  resetMove(bool) {
    this.isReset = bool

    if (this.isReset) {
      this.pictureX(0)
      this.pictureY(0)
      this.moveX(0)
      this.moveY(0)

      this.items.forEach((item) => {
        item.moveX(0)
        item.moveY(0)
      })
    }
  }

  itemHover(bool, e) {
    if (this.isDisabled) return

    this.gridToggle()

    if (bool) this.titleFill(e.currentTarget.dataset.title, e.currentTarget.dataset.subtitle)

    const tl = gsap.timeline()

    tl.add(this.titleToggle(!bool), 'start')
    tl.add(this.titleSecondToggle(bool), 'start')
  }

  titleToggle(bool) {
    if (this.titleTl) this.titleTl.kill()

    this.titleTl = gsap.to(this.title, {
      opacity: bool ? 1 : 0, duration: 1.5, filter: bool ? 'blur(0px)' : 'blur(18px)', ease: 'power2.out'
    })

    return this.titleTl
  }

  titleSecondToggle(bool) {
    if (this.titleTlSecond) this.titleTlSecond.kill()

    this.titleTlSecond = gsap.to(this.titleSecond, {
      opacity: bool ? 1 : 0, duration: 1.5, filter: bool ? 'blur(0px)' : 'blur(18px)', ease: 'power2.out'
    })

    return this.titleTlSecond
  }

  titleFill(text, subtext) {
    this.titleSecond.big.innerText = text
    this.titleSecond.min.innerText = subtext
  }

  gridToggle() {
    this.content.classList.toggle('grid__gallery--hover')
  }

  contentHover(bool) {
    App.cursor.toggleMoving(bool)
  }

  appear() {
    const tl = gsap.timeline({
      onComplete: () => {
        this.quickTo()
        this.isInit = true
      }
    })

    tl.to(this.titleBig.split.chars, {
      duration: 1.35, x: 0, filter: 'blur(0px)', opacity: 1, scale: 1, stagger: {
        from: 'end', amount: 0.35
      }, ease: 'power2.out'
    }, 'start')

    tl.to(this.titleMin, { duration: 0.7, opacity: 1, ease: 'quad.out' }, '-=1')
    // tl.add(this.titleToggle(true), 'start')
    // tl.to(this.title, { scale: 1, duration: 1.5, ease: 'power2.out' }, 'start')
    tl.addLabel('step1')
    tl.to(this.content, { scale: 1, duration: 1.7, ease: 'power2.out' }, 'step1')
    tl.to(this.items, {
      scale: 1, clipPath: 'inset(0%)', duration: 1.7, stagger: {
        from: 'center', amount: 0.7
      }, ease: 'expo.out'
    }, 'step1')

    return tl
  }

  appearPicture(bool) {
    const tl = gsap.timeline()

    tl.to(this.pictures, { duration: bool ? 1 : 0.5, opacity: bool ? 1 : 0, ease: 'quad.out' })

    return tl
  }

  appearPanels(bool) {
    const tl = gsap.timeline()

    tl.to(this.panels, { duration: bool ? 1 : 0.5, opacity: bool ? 1 : 0, ease: 'quad.out' })

    return tl
  }

  switchMode(bool) {
    const colSize = App.getColSize()
    const tl = gsap.timeline()

    tl.set(this.items, { clipPath: 'none' })

    tl.to(this.panels, {
      duration: 1.7, y: (e, b) => {
        return bool ? (this.oDrag.items[e].offsetTop - this.items[e].offsetTop) + (this.diffY / 2) : 0
      }, x: (e, b) => {
        const x = bool ? (this.oDrag.items[e].offsetLeft - this.items[e].offsetLeft) + (this.diffX / 2) + (colSize / 2) : 0

        b.currentX = x

        return x
      }, scaleX: (e, b) => {
        return bool ? (this.oDrag.items[e].offsetWidth - colSize) / this.items[e].offsetWidth : 1
      }, scaleY: (e, b) => {
        return bool ? this.oDrag.items[e].offsetHeight / this.items[e].offsetHeight : 1
      }, ease: 'power2.inOut', stagger: {
        from: bool ? 'end' : 'start', amount: 0.5
      }
    })

    return tl
  }

  setPanelX(x) {
    gsap.set(this.panels, {
      x: (a, b) => {
        return b.currentX + x
      }
    })
  }

  disabled(bool) {
    this.isDisabled = this.el.classList.toggle('pointer-events-none', bool)
  }

}
